import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BorderAllIcon(props: IconProps) {
    return <Icon {...props} iconKey={"border_all"}/>
}
